import { WorkforceSource } from 'api/services/workforce/workforce-service.dto';
import { useSearchParams } from 'react-router-dom';
import { useFeatureFlagContext } from 'shared/contexts/feature-flag-provider';

const isWorkforceSource = (value: unknown): value is WorkforceSource =>
  value === 'own' || value === 'borrowed';

export const useSelectedWorkforceTab = () => {
  const { allowBorrowedWorkforce } = useFeatureFlagContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const tabFromUrl = searchParams.get('tab');
  const selectedTab: WorkforceSource =
    allowBorrowedWorkforce && tabFromUrl === 'borrowed' ? 'borrowed' : 'own';

  const handleTabChange = (_: unknown, tabId: unknown) => {
    if (!isWorkforceSource(tabId)) {
      return;
    }

    if (tabId === 'borrowed' && !allowBorrowedWorkforce) {
      return;
    }

    const nextParams = new URLSearchParams(searchParams);
    nextParams.set('tab', tabId);
    setSearchParams(nextParams);
  };

  return { selectedTab, handleTabChange };
};
